var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 6.16652V3.2504C12.3333 2.55729 12.3333 2.21073 12.1873 1.99775C12.0598 1.81167 11.8622 1.68527 11.6398 1.64742C11.3852 1.60411 11.0706 1.74933 10.4413 2.03979L3.04918 5.45152C2.48792 5.71056 2.20729 5.84008 2.00175 6.04095C1.82005 6.21854 1.68135 6.43532 1.59625 6.67472C1.5 6.94551 1.5 7.25459 1.5 7.87274V11.9999M12.75 11.5832H12.7583M1.5 8.83319L1.5 14.3332C1.5 15.2666 1.5 15.7333 1.68166 16.0898C1.84144 16.4034 2.09641 16.6584 2.41002 16.8182C2.76654 16.9999 3.23325 16.9999 4.16667 16.9999H13.8333C14.7668 16.9999 15.2335 16.9999 15.59 16.8182C15.9036 16.6584 16.1586 16.4034 16.3183 16.0898C16.5 15.7333 16.5 15.2666 16.5 14.3332V8.83319C16.5 7.89977 16.5 7.43306 16.3183 7.07654C16.1586 6.76294 15.9036 6.50797 15.59 6.34818C15.2335 6.16652 14.7668 6.16652 13.8333 6.16652L4.16667 6.16652C3.23325 6.16652 2.76654 6.16652 2.41002 6.34818C2.09641 6.50797 1.84144 6.76294 1.68166 7.07654C1.5 7.43306 1.5 7.89977 1.5 8.83319ZM13.1667 11.5832C13.1667 11.8133 12.9801 11.9999 12.75 11.9999C12.5199 11.9999 12.3333 11.8133 12.3333 11.5832C12.3333 11.3531 12.5199 11.1665 12.75 11.1665C12.9801 11.1665 13.1667 11.3531 13.1667 11.5832Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/WalletIcon.8999712d28e27f0c979be98064b77823.svg";
export { ForwardRef as ReactComponent };